import {
  BrainCircuit,
  BriefcaseBusiness,
  HeartHandshake,
  Languages,
  Lightbulb,
  MessageCircle,
  Network,
  RefreshCw,
  ShieldCheck,
  Sparkles,
  UsersRound,
  Video,
  Workflow,
  Zap,
} from 'lucide-react';

export const navItems = [
  { label: 'Platform', href: '#platform' },
  { label: 'Capabilities', href: '#capabilities' },
  { label: 'Use Cases', href: '#use-cases' },
  { label: 'About', href: '#about' },
  { label: 'Early Access', href: '#early-access' },
];

export const capabilities = [
  { title: 'Memory', body: 'Understands what matters', icon: BrainCircuit, accent: 'from-violet-500 to-fuchsia-500' },
  { title: 'Communication', body: 'Express in language', icon: MessageCircle, accent: 'from-sky-500 to-blue-500' },
  { title: 'Voice & Video', body: 'Natural, real-time interactions', icon: Video, accent: 'from-orange-400 to-rose-500' },
  { title: 'Workflow', body: 'Plans and coordinates', icon: Workflow, accent: 'from-emerald-400 to-teal-500' },
  { title: 'Action', body: 'Takes informed, goal-aligned steps', icon: Zap, accent: 'from-amber-400 to-orange-500' },
  { title: 'Human Review', body: "You're always in control", icon: ShieldCheck, accent: 'from-indigo-500 to-purple-500' },
];

export const pillars = [
  { title: 'Learn', body: 'Continuously learns from your world so responses get smarter over time.', icon: Lightbulb },
  { title: 'Connect', body: 'Brings people, tools, and data together into one intelligent workspace.', icon: Network },
  { title: 'Act', body: 'From insight to impact — automates workflows and drives results.', icon: Zap },
  { title: 'Evolve', body: 'Adapts to you, your team, and your goals becoming more valuable every day.', icon: RefreshCw },
];

export const useCases = [
  { title: 'Personal Intelligence', body: 'Your AI-driven collaborator for focus, learning, and personal growth.', icon: UsersRound, gradient: 'from-fuchsia-100 via-white to-violet-100' },
  { title: 'Business Operations', body: 'Streamline operations, align teams, and accelerate execution.', icon: BriefcaseBusiness, gradient: 'from-sky-100 via-white to-indigo-100' },
  { title: 'Care & Support', body: 'Compassionate, context-aware support that makes a difference.', icon: HeartHandshake, gradient: 'from-rose-100 via-white to-orange-100' },
  { title: 'Creative Systems', body: 'Amplify creativity with intelligent tools that help ideas come to life.', icon: Sparkles, gradient: 'from-emerald-100 via-white to-cyan-100' },
];

export const trustNotes = [
  'Privacy-first by design',
  'Human review built in',
  'Context-aware intelligence',
];

export const languageIcon = Languages;
